import "./css/LoadingSpinner3.css";

import React from "react";

function LoadingSpinner3({ dotSize, dotGap }) {
  return (
    <div
      className="dot-container"
      style={{
        width: `${dotGap || dotSize * 4.6}rem`,
      }}
    >
      <div
        style={{
          width: `${dotSize}rem`,
          height: `${dotSize}rem`,
          // left: `-${dotGap || dotSize * 1.5}rem`,
        }}
        className="dot-before"
      ></div>
      <div
        style={{
          width: `${dotSize}rem`,
          height: `${dotSize}rem`,
        }}
        className="dot-mid"
      ></div>
      <div
        style={{
          width: `${dotSize}rem`,
          height: `${dotSize}rem`,
          // left: `${dotGap || dotSize * 1.5}rem`,
        }}
        className="dot-after"
      ></div>
    </div>
  );
}

export default LoadingSpinner3;
